import styled from "styled-components";

export const FixedTopBarContainer = styled.div`
  position: fixed;
  top: 85px;
  left: 0;
  right: 0;
  height: 60px;
  background-color: var(--primary-white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 1000;

  @media (max-width: 1024px) {
    padding: 0 16px;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const FilterButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FilterButton = styled.button`
  border: none;
  outline: none;
  border-radius: 6px;
  background: var(--primary-dark-50);
  color: var(--primary-blue);
  font-weight: 400;
  font-size: var(--fs-base);
  padding: 8px 18px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &.active {
    background: var(--primary-blue);
    color: var(--primary-white);
    font-weight: 600;
  }

  &:hover:not(.active) {
    background: var(--primary-dark-100);
  }
`;

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  background: var(--primary-green);
  color: var(--primary-dark);
  font-size: var(--fs-base);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--primary-green);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    color: var(--primary-dark);
  }
`;
